import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const HandSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default HandSVG;
